import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserFetchStatus = createSelector(
  [(store: RootState) => store.userShow.userFetchStatus],
  (data) => data
);
